import { fr_CA } from '@docupet/component-library';

export default {
  ...fr_CA,
  views: {
    basket: {
      shopNow: 'Achetez maintenant',
      yourBasket: '<strong>Votre panier</strong> ({0} articles): <strong>{1}</strong>',
      noItems: 'Nous avons des trucs sympas que votre panier adorerait!',
      licenseTitle: 'Licence (s) et frais de retard',
      replacementTitle: 'Étiquettes de remplacement',
      tagTitle: 'Tags pour animaux de compagnie',
      productTitle: 'Des produits',
      walletCardProductTitle: 'Carte de portefeuille',
      duplicateWalletCard: 'Carte de portefeuille en double',
      petIdentificationCard: "Carte d'identité des animaux",
      walletCardMissingInfo: "L'information manquante dans vos carte de portefeuille!",
      walletCardFinishPet: "Fini {petName}'s carte",
      walletCardAssignPet: "Attribuer un animal à votre carte",
      donationTitle: 'Des dons',
      vsTitle: 'Articles pour Voice & Sight',
      vsPetTitle: 'Animaux domestiques',
      vsGuardianTitle: "Propriétaire d'animal ou tuteurs",
      addAnother: [
        'ACHETEZ PLUS ET ÉCONOMISEZ PLUS SUR LES ÉTIQUETTES!',
        'Ajoutez une autre étiquette et économisez 5 $!',
        'Ajoutez une autre étiquette et économisez 15 $!!',
        'Ajoutez une autre étiquette pour seulement 10 $!',
      ],
      checkout: 'Vérifier',
      continueShopping: 'Continuer vos achats',
      shipping: 'Free shipping on all orders over $00.00',
      returnPolicy: 'Something about our return policy',
      warranty: 'Something about our warranty',
    },
    confirmation: {
      thanks: 'Merci pour votre achat!',
      orderNumber: 'Commande n ° {0}',
      gettingReady: "Nous préparons votre commande pour l'expédition. Nous vous informerons quand il aura été envoyé.",
      toAccount: 'Accéder à mon Compte',
      viewOrder: 'Voir votre commande',
      summary: 'Récapitulatif de la commande',
    },
    donation: {
      wouldYouLike: 'Souhaitez-vous faire un don à notre Safe&Happy Fund?',
      netProceeds:
        "Tous les bénéfices nets sont reversés à l'assistance {0}. Si vous souhaitez recevoir un reçu aux fins d’impôt, veuillez faire un don directement à votre refuge local ou à votre organisme de services aux animaux.",
      selectAmount: 'Sélectionnez le montant de votre don',
      continue: 'Ajouter un don et continuer à payer',
      skip: "Pas de don aujourd'hui, merci - Continuer",
      cartTotal: 'Total du panier: {0}',
    },
    payment: {
      donationSuccess: 'Don ajouté. Merci!',
      place: 'Passer votre commande',
      shippingTo: 'Expédition à: ',
      editAddress: 'Éditer',
      error: "Euh! Une erreur s'est produite lors du traitement de votre carte.",
      info: 'Informations de paiement',
      creditDebit: 'Carte de crédit',
      onFile: 'Carte au dossier',
      useFile: 'Utiliser la carte dans le fichier',
      useDifferent: 'Utiliser une autre carte',
    },
  },
  components: {
    discount: {
      notApplyTip:
        "Les codes promotionnels ne s'appliquent pas aux frais de licence pour animaux de compagnie, aux frais de retard, aux étiquettes de remplacement pour animaux de compagnie, aux articles groupés ou aux articles en vente spécifiques.",
      success: '',
      error: '',
      excludesSaleItems: 'Les codes promotionnels ne peuvent pas être utilisés sur les articles en solde.',
    },
    petHeader: {
      for: 'Articles pour {0}',
    },
    product: {
      personalization: 'Personnalisation',
    },
    stripe: {
      AM: 'Amex',
      MC: 'Mastercard',
      VI: 'Visa',
      NN: 'Discover',
      XX: 'Card',
      profile: '{0} se terminant par {1} expirant le {2}/{3}',
    },
    totals: {
      subtotal: 'Sous-total',
      discount: 'Réduction',
      shipping: 'Livraison',
      tax: 'Tax ({0}) {1}%',
      fees: 'Frais',
      feesTip: 'Frais de traitement en ligne de {0}',
      donation: 'Don',
      total: 'Total',
    },
    removeBundleItemConfirmation: {
      title: 'Êtes-vous sûr de vouloir supprimer cet article de votre panier?',
      message: 'Cela supprimera tous les éléments associés {petName}.',
      confirmButtonText: "Oui, supprimez l'élément",
      cancelButtonText: 'Non, gardez cet article',
    },
  },
};
